import axios from "../utils/AxiosInstance";
import { ResponseMessage } from "../models/ResponseMessage";
import { Constants } from "../constants/constants";
import { Plan } from "../models/SubscriptionModels";
import { CreatePlanRequest, UpdatePlanRequest } from "../models/PlanModels";

const API_BASE_URL = Constants.API_BASE_URL;

const authHeaders = (token: string) => ({
  Authorization: `Bearer ${token}`,
});

export async function getAllPlansAsync(
  token: string,
): Promise<ResponseMessage<Plan[]>> {
  const response = await axios.get(`${API_BASE_URL}/plans`, {
    headers: authHeaders(token),
  });

  return ResponseMessage.fromJson(response.data);
}

export async function createPlanAsync(
  token: string,
  request: CreatePlanRequest,
): Promise<ResponseMessage<Plan>> {
  const response = await axios.post(`${API_BASE_URL}/plans`, request, {
    headers: authHeaders(token),
  });

  return ResponseMessage.fromJson(response.data);
}

export async function updatePlanAsync(
  token: string,
  id: string,
  request: UpdatePlanRequest,
): Promise<ResponseMessage<boolean>> {
  const response = await axios.put(`${API_BASE_URL}/plans/${id}`, request, {
    headers: authHeaders(token),
  });

  return ResponseMessage.fromJson(response.data);
}

export async function deletePlanAsync(
  token: string,
  id: string,
): Promise<ResponseMessage<boolean>> {
  const response = await axios.delete(`${API_BASE_URL}/plans/${id}`, {
    headers: authHeaders(token),
  });

  return ResponseMessage.fromJson(response.data);
}